import React, { useContext, useState } from 'react';
import { Grid, Icon, Dropdown, List, Ref } from 'semantic-ui-react';

import { ButtonLink, EllipsisDropdown, LinkedAccount, Table } from 'dyl-components';
import { Link } from 'react-router-dom';
import { StatusDropdown } from 'pages/Accounts/subcomponents/ConversionControls';
import { FormsContext } from 'pages/Accounts/subcomponents/FormsProvider';
import { useDispatch, useSelector } from 'react-redux';
import { PhoneUtil } from 'utils';
import { ActivityPopup } from 'shared/forms/NewActivity';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';
import TextIcon from 'shared/TextIcon';
import { TextMessageModal } from 'shared/modals';
import SendEmailModal from 'shared/modals/SendEmailModal';

const DropdownItem = ({ text, icon, ...otherProps }) => {
    return (
        <Dropdown.Item text={<React.Fragment>
            <Icon name={icon} />
            {text}
        </React.Fragment>}
            style={{ cursor: 'pointer' }}
            {...otherProps}
        />
    );
}

export const Account = ({
    name,
    id,

    primary_contact,
    counts,
    pinned,
    customer,
    master_account_id,
    account
}) => {
    console.log("|+|account", account)
    const dispatch = useDispatch();
    const { contact_count, lead_count, opportunity_count } = counts
    const { onStatusDropdownSelect, onLinkSelect, onUnlinkSelect } = useContext(FormsContext)
    const actionPopupRef = React.createRef();
    const userPhoneCreds = useSelector(state => state?.officeView?.creds)
    const hasEmailIntegrations = useSelector(state => state.oauth_integrations.integrations?.length > 0);
        const [openForm, setOpenForm] = useState(false);
    const onOpenForm = (type) => {
        setOpenForm(type);
    }
    const onCloseForm = () => {
        setOpenForm('');
    }
        const isPhoneSystemSupported = PhoneUtil.isPhoneSystemSupported(userPhoneCreds);
    const ELLIPSIS_OPTIONS = [
        {
            id: 1,
            text: 'Change Master Account',
            icon: 'fa-solid fa-buildings',
            onClick: (e,id,master_id)=>{
                onLinkSelect(id,master_id);
            },
            userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_EDIT
        },
        {
            id:2,
            text: 'Unlink Master Account',
            icon: 'fas fa-diagram-nested',
            onClick: (e,id,master_id)=>{
                onUnlinkSelect(actionPopupRef,{account_id: id ,master_account:master_id});
            },
            userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_EDIT
        }
    ];

    const onClickToDial = () => {
        const destination = primary_contact?.primary_phone?.phone;
        const contact_id = primary_contact?.id;
        PhoneUtil.C2D({ payload: { account_id: id, contact_id, destination }, dispatch })
    }

    return (
        <React.Fragment>
            <Table.Row>
                <Table.Cell>
                    {pinned && <Icon color='primary' link className='fas thumbtack' />}
                </Table.Cell>
                <Table.Cell>
                    <LinkedAccount
                        account={name}
                        maxWidth={'9em'}
                        subtitle={id && `ID: ${id}`}
                        popup
                        linkToAccount={
                        <RestrictedView type="link" userPermission={USER_PERMISSIONS.ACCOUNT_VIEW} userRestrict assignmentIds={[(account?.owner_id || 0), (account?.coowner_id || 0)]}>
                            <Link target={'_blank'} to={`/account/${id}`}>{name}</Link>
                        </RestrictedView>
                        }
                    />
                </Table.Cell>
                <Table.Cell>
                    {primary_contact?.id && (
                        <Grid columns='equal' verticalAlign='middle'>
                            <Grid.Column>
                                <LinkedAccount
                                    maxWidth={'9em'}
                                    account={`${primary_contact.first_name} ${primary_contact.last_name}`}
                                    subtitle={primary_contact.primary_email?.email}
                                    linkToAccount={
                                    <RestrictedView type="link" userPermission={USER_PERMISSIONS.CONTACTS_VIEW} userRestrict assignmentIds={[(account?.primary_contact?.owner_id || 0), (account?.primary_contact?.coowner_id || 0)]}>
                                        <Link target={'_blank'} to={`/contact/${primary_contact.id}`}>{primary_contact.first_name} {primary_contact.last_name}</Link>
                                    </RestrictedView>    
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column>
                                {isPhoneSystemSupported ?
                                    <Icon onClick={onClickToDial} disabled={!primary_contact.primary_phone?.phone} link color='primary' className='fas fa-phone' />
                                    : <ActivityPopup
                                        trigger={
                                            <Icon link color='primary' className='fas fa-phone' />
                                        }
                                        activityProps={{
                                            hideActivitySelection: true,
                                            contact: { id: primary_contact?.id },
                                            isContact: true
                                        }}
                                        open={openForm === 'call'}
                                        onOpen={() => onOpenForm('call')}
                                        onClose={onCloseForm}
                                    />}
                                <TextIcon 
                                    account_id={id}
                                    contact_id={primary_contact?.id}
                                    isActivityFormOpen={openForm === 'text'}
                                    onCloseActivityForm={onCloseForm}
                                    onOpenActivityForm={() => {onOpenForm('text')}}
                                    onOpenTextModal={() => {onOpenForm('text-modal')}}
                                    phone={primary_contact.primary_phone?.phone}
                                    primary
                                />
                                {primary_contact.primary_email?.email ?
                                    hasEmailIntegrations ? <Icon className='fa-solid fa-envelope' color='primary' link onClick={() => {
                                        onOpenForm('email-modal');
                                    }} /> :
                                    <ActivityPopup
                                        trigger={
                                            <Icon className='fas fa-envelope' color='primary' link onClick={() => {onOpenForm('email')}} />
                                        }
                                        activityProps={{
                                            emailOnly: true,
                                            contact: {
                                                ...primary_contact,
                                                email: primary_contact.primary_email
                                            }
                                        }}
                                        open={openForm === 'email'}
                                        onOpen={() => onOpenForm('email')}
                                        onClose={onCloseForm}
                                    />
                                    : <Icon className='fa-solid fa-envelope' color='primary' link disabled />
                                }
                                <TextMessageModal
                                    open={openForm === "text-modal"}
                                    onClose={onCloseForm}
                                    contact_name={`${primary_contact.first_name} ${primary_contact.last_name}`}
                                    contact_id={primary_contact?.id}
                                />
                                <SendEmailModal
                                    open={openForm === "email-modal"}
                                    onClose={onCloseForm}
                                    contact_id={primary_contact?.id}
                                />
                            </Grid.Column>
                        </Grid>
                    )}
                </Table.Cell>
                <Table.Cell>
                    <List>
                        <List.Item>
                            <ButtonLink>{contact_count || 0} contact{contact_count > 1 && 's'}</ButtonLink>
                        </List.Item>
                        <List.Item>
                            <ButtonLink>{lead_count || 0} lead{lead_count > 1 && 's'}</ButtonLink>
                        </List.Item>
                        <List.Item>
                            <ButtonLink>{opportunity_count || 0} {opportunity_count > 1 ? 'opportunities' : 'opportunity'}</ButtonLink>
                        </List.Item>
                    </List>
                </Table.Cell>
                <Table.Cell>
                    {customer.customer_fund_type !== "unfunded" && <StatusDropdown
                        account={{
                            ...customer,
                            ...account,
                            account_status: customer.customer_status,
                            id: id,
                            fund_type: customer.customer_fund_type,
                        }}
                        onStatusDropdownSelect={onStatusDropdownSelect}
                    />}
                </Table.Cell>
        <Table.Cell>
            <EllipsisDropdown>
                        {ELLIPSIS_OPTIONS.map(({ text, icon, userPermission, ...otherProps }, idx) => {
                            return (
                                <Ref innerRef={actionPopupRef}>
                                    <RestrictedView type="disabled" userPermission={userPermission}>
                                        <DropdownItem
                                            key={idx}
                                            text={text}
                                            icon={icon}
                                            {...otherProps}
                                            onClick={
                                                (e) => {
                                                    otherProps.onClick(e, id, master_account_id);
                                                }
                                            }
                                        />
                                    </RestrictedView>
                                </Ref>
                            );
                        })}
                    </EllipsisDropdown>
                </Table.Cell>
            </Table.Row>
        </React.Fragment>
    )
}
